import { render, staticRenderFns } from "./new-copy-of-code-settings-modal.vue?vue&type=template&id=1ee32d0d&scoped=true&"
import script from "./new-copy-of-code-settings-modal.vue?vue&type=script&lang=js&"
export * from "./new-copy-of-code-settings-modal.vue?vue&type=script&lang=js&"
import style0 from "./new-copy-of-code-settings-modal.vue?vue&type=style&index=0&id=1ee32d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee32d0d",
  null
  
)

export default component.exports